import { createFileRoute } from '@tanstack/react-router'

// Leaf route — `withPlan` variant without a pinId (short variant).
// PlanViewerNew is mounted by the parent $viewType/route.tsx layout;
// `planId` is read by the container via useParams({ strict: false }).
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/pins/$viewType/$planId/'
)({
  component: () => null
})
